// Chakra Icons
import { BellIcon } from '@chakra-ui/icons'
// Chakra Imports
import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
  Text,
  useColorMode,
  useColorModeValue
} from '@chakra-ui/react'
// Assets
import avatar1 from 'assets/img/avatars/avatar1.png'
import avatar2 from 'assets/img/avatars/avatar2.png'
import avatar3 from 'assets/img/avatars/avatar3.png'
// Custom Icons
import {
  ArgonLogoDark,
  ArgonLogoLight,
  ChakraLogoDark,
  ChakraLogoLight,
  ProfileIcon,
  SettingsIcon
} from 'components/Icons/Icons'
// Custom Components
import { ItemContent } from 'components/Menu/ItemContent'
import { SearchBar } from 'components/Navbars/SearchBar/SearchBar'
import { SidebarResponsive } from 'components/Sidebar/Sidebar'
import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { dashRoutes as routes } from 'routers'

export default function HeaderLinks(props) {
  const {
    variant,
    children,
    fixed,
    scrolled,
    secondary,
    onOpen,
    ...rest
  } = props

  const { colorMode } = useColorMode()
  const { pathname } = useLocation();
  
  // clear data user select when navigating page edit assign individual-training
  if (
    !pathname.includes("/admin/individual-training/courses/edit") &&
    !pathname.includes("/admin/individual-training/assign-training")
  ) {
    sessionStorage.removeItem("useSelectedList");
    sessionStorage.removeItem("courseId");
  }

  // clear data user select when navigating page create course individual
  if (
    !pathname.includes("/admin/individual-training/courses/create")
  ) {
    sessionStorage.removeItem("dataCreateCourseIndividual");
  }

  // Chakra Color Mode
  let navbarIcon =
    fixed && scrolled
      ? useColorModeValue('gray.700', 'gray.200')
      : useColorModeValue('white', 'gray.200')
  let menuBg = useColorModeValue('white', 'navy.800')
  if (secondary) {
    navbarIcon = 'white'
  }
  return (
    <Flex
      pe={{ sm: '0px', md: '16px' }}
      w={{ sm: '100%', md: 'auto' }}
      alignItems='center'
      flexDirection='row'
    >
      {/* <SearchBar me='18px' /> */}
      {/* <NavLink to='/auth/signin'>
        <Button
          ms='0px'
          px='0px'
          me={{ sm: '2px', md: '16px' }}
          color={navbarIcon}
          variant='no-effects'
          rightIcon={
            document.documentElement.dir ? (
              ''
            ) : (
              <ProfileIcon color={navbarIcon} w='22px' h='22px' me='0px' />
            )
          }
          leftIcon={
            document.documentElement.dir ? (
              <ProfileIcon color={navbarIcon} w='22px' h='22px' me='0px' />
            ) : (
              ''
            )
          }
        >
          <Text display={{ sm: 'none', md: 'flex' }}>Sign In</Text>
        </Button>
      </NavLink> */}
      <SidebarResponsive
        hamburgerColor={'white'}
        logo={
          <Stack direction='row' spacing='12px' align='center' justify='center'>
            {colorMode === 'dark' ? (
              <ArgonLogoLight w='74px' h='27px' />
            ) : (
              <ArgonLogoDark w='74px' h='27px' />
            )}
            <Box
              w='1px'
              h='20px'
              bg={colorMode === 'dark' ? 'white' : 'gray.700'}
            />
            {colorMode === 'dark' ? (
              <ChakraLogoLight w='82px' h='21px' />
            ) : (
              <ChakraLogoDark w='82px' h='21px' />
            )}
          </Stack>
        }
        colorMode={colorMode}
        secondary={props.secondary}
        routes={routes.filter((route) => route.layout === '/admin')}
        {...rest}
      />
      {/* <Menu>
        <MenuButton>
          <BellIcon color={navbarIcon} w='18px' h='18px' />
        </MenuButton>
        <MenuList p='16px 8px' bg={menuBg}>
          <Flex flexDirection='column'>
            <MenuItem borderRadius='8px' mb='10px'>
              <ItemContent
                time='13 minutes ago'
                info='from Alicia'
                boldInfo='New Message'
                aName='Alicia'
                aSrc={avatar1}
              />
            </MenuItem>
            <MenuItem borderRadius='8px' mb='10px'>
              <ItemContent
                time='2 days ago'
                info='by Josh Henry'
                boldInfo='New Album'
                aName='Josh Henry'
                aSrc={avatar2}
              />
            </MenuItem>
            <MenuItem borderRadius='8px'>
              <ItemContent
                time='3 days ago'
                info='Payment succesfully completed!'
                boldInfo=''
                aName='Kara'
                aSrc={avatar3}
              />
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu> */}
    </Flex>
  )
}
